import { render, staticRenderFns } from "./quotation2.vue?vue&type=template&id=35674aa6&scoped=true&"
import script from "./quotation2.vue?vue&type=script&lang=js&"
export * from "./quotation2.vue?vue&type=script&lang=js&"
import style0 from "./quotation2.vue?vue&type=style&index=0&id=35674aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35674aa6",
  null
  
)

export default component.exports